import { createSelector } from 'reselect'
import { State } from '../../reducers/reducerType'

/**
 * The channel feature flag that marks a channel as a real-time (IVS) talk.
 * When enabled the talk is handled by the talks-real-time app rather than
 * talks-present.
 */
export const IVS_TALK_FEATURE = 'ivstalk'

const getChannelFeatures = (state: State) => state.channel.data.features

/**
 * Determines whether the current channel has the `ivstalk` feature enabled by
 * looking it up by name in the channel's features and checking it is enabled.
 * @param state The Redux state
 */
export default createSelector(
  [getChannelFeatures],
  (features) => features.some((feature) => feature.name === IVS_TALK_FEATURE && feature.enabled)
)
